import React from "react";

export default ({ handleChange, handleSubmit, post }) => {
  return (

    // <div className="p-5" style={{background: 'linear-gradient(to right, #E9E9E9, #E8E8E8'}}>
    // <div className="p-5" style={{ borderRadius: "20% 60% 50% 30% / 90% 70% 50% 30%", background: 'linear-gradient(to right, #E9E9E9, #E8E8E8'}}>
    <div className="p-5 m-2 border" style={{
      borderRadius: "30% 60% 50% 20% / 30% 40% 50% 90%",
      background: 'linear-gradient(to right, #f8eee7, #f4decb',
      background: '#f8eee7',
      position: "relative",
      overflow: "hidden",
    }}>

      <div className="pb-2 mb-2">
        {/* will write conetnt here */}
        <br></br>
        <h5 className="p-2 m-2 text" style={{ fontWeight: "thin", color: "#52658f" }}>
          To view the exon nomenclature and their visualization in protein coding transcripts, please enter below gene name/symbol, or NCBI gene id (Entrez)</h5>
        <br /><br /><br /><br />
      </div>
      <br />
      <div
        className="form-container position-relative" align="left"
        style={{
          display: "flex",
        }}
      >

        <form>
          <div className="mb-5">
            <label for="exampleInputEmail1" className="form-label" style={{ color: "#333a56" }}>Enter here</label>
            <input
              className="col-sm-12"
              name="name"
              onChange={handleChange}
              type="text"
              value={post.name}
            // placeholder="Gene Name or NCBI gene Id"
            // width="100px"
            // height="30px"
            />
            <div id="passwordHelpBlock" class="form-text">
              Your input should be either numeric (Entrez identifier) or name of gene.
            </div>

            <div id="passwordHelpBlock" class="form-text" style={{ fontWeight: "bold", color: "#52658f", fontSize: '12px', paddingTop: '12px' }}>
              *Enter 3+ alphanumeric characters to refine gene name search (max 200 results).
            </div>
            <br></br>

          </div>
          <br></br>
          <div className="mb-2 ml-2">
            <button className="btn" onClick={handleSubmit} style={{ background: "#d79d75", color: "white" }}>
              {/* style={{background:"#88D317",color:"White"}} */}
              <b>Submit</b>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
